export default "__VITE_ASSET__BrJd6Yrt__"